import styled from 'styled-components';

export const Container = styled.div`
  width: ${({ itemSize }) => itemSize.width};
  height: ${({ itemSize }) => itemSize.height};
  background-color: ${({ bgColor }) => bgColor};
  margin: 0 12px;
  flex-shrink: 0;
`;
